import axios from 'axios'
import {asResponse} from '../util'

const convertActivePageToSkip = (query = {}) => {
  let {activePage = '1'} = query
  activePage = parseInt(activePage)
  return (activePage - 1) * 10
}

export const NOTIFICATIONS_SWR_KEY = ({query = {}, me}) => {
  const skip = convertActivePageToSkip(query)
  return [`/bff/notifications/pending?skip=${skip}&limit=10&sort={"createdAt": -1}&calcTotalCount=true`, skip, me]
}

export const getNotifications = async (url, skip, me) => {
  if (!me || !me.id) {
    return {notifications: [], totalNotificationsCount: 0}
  }
  const resp = await asResponse(axios.get(url))
  let notifications = resp.data ? (resp.data.results || []) : []
  const {metadata = {}} = resp.data
  const {totalCount: totalNotificationsCount} = metadata
  return {notifications, totalNotificationsCount}
}

export const markNotificationViewed = async (notificationId) => {
  const resp = await asResponse(axios.post(`/bff/notifications/mark-viewed`, {notificationId}))
  return resp.data
}